<payee-form-field
  height="auto"
  [width]="width()"
>
  <ng-content
    payee-label
    select="[payee-label]"
  ></ng-content>

  <div
    class="otp-digits"
    role="group"
  >
    @for (digit of digits; track $index; let i = $index) {
      <input
        #digitInput
        class="otp-digit"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="1"
        autocomplete="one-time-code"
        [attr.aria-label]="'Digit ' + (i + 1)"
        [disabled]="disabled"
        [ngModel]="digit()"
        (ngModelChange)="onDigitChange(i, $event)"
        (paste)="onPaste(i, $event)"
        (keydown.backspace)="onBackspace(i, $event)"
        (blur)="onBlur()"
      />
    }
  </div>

  <ng-content
    payee-error
    select="[payee-error]"
  ></ng-content>
</payee-form-field>
